import type { ErrorItem } from '@contexts/ErrorContext';
import { CloseIcon, ErrorIcon, SuccessIcon } from '@gurupay/gp-ui-library';
import clsx from 'clsx';
import type { FC } from 'react';
import { toast } from 'sonner';

interface ToastProps {
	type: 'success' | 'error';
	message: string;
	onClose: () => void;
}

export const Toast: FC<ToastProps> = ({ message, type, onClose }) => (
	<div
		className={clsx(
			'flex py-space-16 px-space-12 border-1 rounded-lg gap-space-8 min-w-[320px] max-w-[420px] shadow-small',
			type === 'error'
				? 'border-status-error-300 bg-status-error-50'
				: 'border-status-success-300 bg-status-success-50',
		)}
		data-testid="success-toast"
	>
		{type === 'error' ? <ErrorIcon /> : <SuccessIcon />}
		<div className="text-sm-bold flex-1">{message}</div>
		<CloseIcon className="cursor-pointer" onClick={onClose} role="button" tabIndex={0} />
	</div>
);

export const toastSuccess = (message: string) =>
	toast.custom(
		(id) => <Toast message={message} onClose={() => toast.dismiss(id)} type="success" />,
		{ duration: 3000 },
	);

export const toast422 = (errors: ErrorItem[]) =>
	errors.map((error) =>
		toast.custom(
			(id) => (
				<Toast
					message={error.message?.message ?? error.message}
					onClose={() => toast.dismiss(id)}
					type="error"
				/>
			),
			{ duration: 3000 },
		),
	);

export const toastError = (error: string) =>
	toast.custom(
		(id) => <Toast message={error} onClose={() => toast.dismiss(id)} type="error" />,
		{ duration: 3000 },
	);
